module.exports = __webpack_public_path__ + "static/media/step-02.d47c453c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/montemar-card-calf/img/step-02.png
 ** module id = 2060
 ** module chunks = 0
 **/